import React, { useEffect, useState } from 'react';
import moment from 'moment';
import useAuth from '../../hooks/useAuth';
import './News.css';
import { INDEX_URL, SITE_TITLE } from '../../utils/constants';
import { seo } from '../../utils/seo';
import GearSpinner from '../../components/GearSpinner/GearSpinner';
import NewsServices from '../../services/NewsService';

const ListPage = () => {
	const { user } = useAuth();
	const [showSpinner, setShowSpinner] = useState(1);
	const [newsData, setNewsData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [newsPerPage] = useState(10); // how many news items per page
	const indexOfLastNews = currentPage * newsPerPage;
	const indexOfFirstNews = indexOfLastNews - newsPerPage;
	const currentNews = newsData.slice(indexOfFirstNews, indexOfLastNews);
	const totalPages = Math.ceil(newsData.length / newsPerPage);


	const newsServices = new NewsServices();

	useEffect(() => {
		seo({
			title: SITE_TITLE + ' || Dashboard',
			metaDescription: '',
		});
		getNews();
	}, [user]);

	const getNews = () => {
		newsServices.getNewsData({portal_user_id : user.id}).then((response) => {
			setShowSpinner(0);
			if (response.status === 200) {
				if (response.data.status === 'success') {
					setNewsData(response.data.result);
				} else {
					setNewsData([]);
				}
			} else {
				setNewsData([]);
			}
		});
	}
	
	return(
		<React.Fragment>
			<main className="techtop-middle-div">
				<section className="techtop-news-section pb-5">
					<div className="container">
						{/* Page Title */}
						<div className="row">
							<div className="col-md-12">
								<div className="techtop-default-title2">
									<div className="row">
										<div className="col-md-6">
											<h1 className="m-0 dark-color1">Techtop News</h1>
										</div>
										<div className="col-md-6 text-end">
											<h1 className="m-0 dark-color1">{user.name}</h1>
										</div>
									</div>
								</div>
                                <div className="row">													 
									<div className="col-md-12 mt-3">
										{showSpinner === 1 && 
											<React.Fragment>
												<div className="mt-5">
													<GearSpinner/>
													</div>
											</React.Fragment>
										}
										{showSpinner === 0 && newsData.length === 0 && 
											<React.Fragment>
												<div className="techtop-no-record-div mt-5 text-center">
													<h4 className="m-0 dark-color1">No News Found</h4>
												</div>
											</React.Fragment>
										}
										{showSpinner === 0 && currentNews.length > 0 && currentNews.map((news, index) => (
											<React.Fragment key={index}>
												<div className="techtop-news-div" onClick={() => window.location.href=INDEX_URL+'news-details/'+news.permalink} style={{cursor: 'pointer'}}>
													<h6 className="red-text">{moment(news.created_at).format('D MMM, YYYY')}</h6>
													<h4>{news.title}</h4>
													<p>{news.short_description}</p>
												</div>
												{index !== currentNews.length - 1 && <hr className='news-hr' />}
											</React.Fragment>
										))}
									</div>
								</div>
								{showSpinner === 0 && currentNews.length > 0 &&
									<React.Fragment>
										<div className="row mt-5">
											<hr />
											<div className="col-md-12 mt-3">
												<nav aria-label="Page navigation example">
													<ul className="pagination justify-content-center flex-wrap">
													<li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
														<button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
													</li>
													{Array.from({ length: totalPages }, (_, i) => (
														<li className={`page-item ${currentPage === i + 1 ? 'active' : ''}`} key={i}>
														<button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
														</li>
													))}
													<li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
														<button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
													</li>
													</ul>
												</nav>
											</div>
										</div>
									</React.Fragment>
								}
							</div>
						</div>
					</div>
				</section>
			</main>
		</React.Fragment>
	)
}

export default ListPage;